import { SimType } from 'utils/api/payloads/microApi';

export const simDetails = (phoneNumber: string, serialNo?: string | null) => {
	return {
		url: `resource-inventory/sim-details?phoneNumber=${phoneNumber}&serialNo=${serialNo}`,
		method: 'GET',
	};
};

export const esimReplacement = () => {
	return {
		url: `resource-inventory/validate-esim-replacement`,
		method: 'POST',
	};
};

export const sendQrEmail = () => {
	return {
		url: `resource-inventory/qr-email`,
		method: 'POST',
	};
};

export const submitProductOrder = () => {
	return {
		url: `resource-inventory/validate-submit`,
		method: 'POST',
	};
};

export const checkIfResourceIsAvailable = (data: string) => {
	return {
		url: `resource-inventory/availability?serialNumber=${data}`,
	};
};

export const getAvailableNumbers = (rowCount: string, numberSearch?: string) => {
	return {
		url: `resource-inventory/numbers?numberSearch=${numberSearch ? numberSearch : ''}&rowCount=${rowCount}`,
	};
};

export const addSimCard = (type?: SimType) => {
	return {
		url: `order-management/services/validate-service-order/${type}`,
		method: 'POST',
	};
};

export const deleteSimCard = (type?: SimType) => {
	return {
		url: `order-management/services/service-order/${type}`,
		method: 'DELETE',
	};
};

export const replaceSimCard = (type?: SimType) => {
	return {
		url: `order-management/services/service-order/replace/${type}`,
		method: 'POST',
	};
};
